//core
import React, { useState, useEffect } from "react";
import arePropsEqual from "react-fast-compare";
import { Tooltip } from "@mui/material";

//styles
import { useStyles } from "./styles";

//routes
import routes from "../../../../../navigation/routes";

interface IText {
  value: string | number | null;
  hasMultiAccount?: boolean;
}

const ClickableUserId = ({
  value = '',
  hasMultiAccount = false,
}: IText) => {
  const styles = useStyles();

  const [link, setLink] = useState<string>('');

  useEffect(() => {
    const basePath = hasMultiAccount
      ? routes.admin.partners.account.multiAccounts
      : routes.admin.partners.account.main;

    setLink(basePath.replace(':affId', `${value}`));
  }, [value, hasMultiAccount]);

  return (
    <>
      {value
        ? <Tooltip title={value}>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.text}`}
          >
            { value }
          </a>
        </Tooltip>
        : '—'}
    </>
  );
};

export default React.memo(ClickableUserId, arePropsEqual);
